export default __webpack_public_path__ + "static/media/me3_SSO_Register.8cf3988a.svg";